import { ContentLayout } from "components/generic";
import AppsContainersTab from "tabs/apps-container-tab";
import {
    AppsContainerTabContextProvider,
    useAppsContainerTabContext,
} from "storage/context/apps-container-tab-context";
import GoAiguaSwitch from "components/generic/goaiguaswitch";
import { useTranslation } from "utils/hooks/use-translation.hook";

const WelcomePageHeader = () => {
    const { isAdminUser, isImplantUser, editActive, setEditActive } =
        useAppsContainerTabContext();

    const translate = useTranslation();

    return (
        <div className="l-launcher-layout__page-header">
            {translate("app.Pages.Welcome")}
            {isAdminUser || isImplantUser ? (
                <div className="l-launcher-layout__edit-mode-switch">
                    <span className="l-launcher-layout__switch-label">
                        {translate("app.welcome.page.edit_mode_switch")}
                    </span>
                    <div className="l-launcher-layout__switch-container">
                        <GoAiguaSwitch
                            onClick={() => setEditActive(!editActive)}
                            switched={editActive}
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

const WelcomePage = () => {
    const tabs: any[] = [
        {
            id: "welcome",
            title: "Tab de prueba 1",
            content: () => <AppsContainersTab />,
        },
    ];

    return (
        <AppsContainerTabContextProvider>
            <ContentLayout
                title={<WelcomePageHeader />}
                tabs={tabs}
                showTabs={false}
            />
        </AppsContainerTabContextProvider>
    );
};

export default WelcomePage;
